import {useEffect, useState, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import TabCriteriaFilters from "./TabCriteriaFilters";
import TabCriteriaTable from "./TabCriteriaTable";
import TabCriteriaModalMassiveData from "./TabCriteriaModalMassiveData";

const TabCriteria = ({dynamicAssets, steps, stepsTabs, setKeyTab, editing}) => {
    const [activeMassive, setActiveMassive] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [dynamicAssetsShow, setDynamicAssetsShow] = useState([]);
    const [counter, setCounter] = useState("0/0");
    const [modalShow, setModalShow] = useState(false);

    const items = useRef({
        all: [],
        showed: [],
        chosen: [],
        checkboxes: [],
    });
    useEffect(() => {
        if (steps.addAssets) {
            setCounter("0/" + dynamicAssets.current.length);
            items.current.all = [...dynamicAssets.current];
            items.current.showed = [...dynamicAssets.current];
            setDynamicAssetsShow([...dynamicAssets.current]);
            setCheckedAll(false);
        } else {
            setCounter("0/0");
            items.current.all = [];
            items.current.showed = [];
            setDynamicAssetsShow([]);
        }
        items.current.chosen = [];
        items.current.checkboxes.forEach((ele) => {
            ele.checked = false;
        });
        items.current.checkboxes = [];
        setCheckedAll(false);
        stepsTabs.setFiltersDynamic(steps.addAssets);
    }, [steps.addAssets]);

    useEffect(() => {
        if (editing.data.criteria) {
            // console.log("[TabCriteria].useEffect()[editing.data.criteria]");
            stepsTabs.setClassifyAssets(true);
            stepsTabs.enableTab("preview");
            editing.set("preview", true);
        }
    }, [editing.data.criteria]);

    const handleClickMassive = () => {
        setModalShow(true);
        stepsTabs.setClassifyAssets(false);
        stepsTabs.disableTab("preview");
    };

    const handleClickPreview = () => {
        stepsTabs.setClassifyAssets(true);
        stepsTabs.enableTab("preview");
        setKeyTab("preview");
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col h5" style={{maxWidth: "100px"}}>
                    <FontAwesomeIcon icon="filter" /> Filtros:
                </div>
                <TabCriteriaFilters
                    steps={steps}
                    items={items}
                    setDynamicAssetsShow={setDynamicAssetsShow}
                    setCheckedAll={setCheckedAll}
                    setCounter={setCounter}
                    setActiveMassive={setActiveMassive}
                />
                <div className="col d-flex justify-content-end">
                    <div className="text-center">
                        <div>Modificación</div>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            disabled={!activeMassive}
                            onClick={handleClickMassive}>
                            <FontAwesomeIcon icon="pen" className="me-1" /> Masiva de: {counter}
                        </button>
                    </div>
                    <div className="ms-2 pt-4">
                        <button type="button" className="btn btn-primary" onClick={handleClickPreview}>
                            <FontAwesomeIcon icon="eye" className="me-1" /> Previa
                        </button>
                    </div>
                </div>
                <div className="col-12">
                    <TabCriteriaTable
                        dynamicAssets={dynamicAssets}
                        dynamicAssetsShow={dynamicAssetsShow}
                        setDynamicAssetsShow={setDynamicAssetsShow}
                        checkedAll={checkedAll}
                        setCheckedAll={setCheckedAll}
                        items={items}
                        setCounter={setCounter}
                        setActiveMassive={setActiveMassive}
                        stepsTabs={stepsTabs}
                    />
                </div>
            </div>
            <TabCriteriaModalMassiveData
                show={modalShow}
                setShow={setModalShow}
                setDynamicAssetsShow={setDynamicAssetsShow}
                items={items}
                dynamicAssets={dynamicAssets}
                stepsTabs={stepsTabs}
            />
        </div>
    );
};
export default TabCriteria;
